import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { _ } from '../../../js/globals';
import { ClientLoggerService } from '../../services/client-logger.service';
import { PerformanceContextService } from '../../services/performance-context.service';
import { PerformanceMetricsService } from '../../services/performance-metrics.service';
import { PerformanceContext } from '../../interfaces/mysynch.interfaces';

@Component({
    standalone: false,
    selector: 'password-reset',
    templateUrl: '../app/pages/password-reset/password-reset.view.html',
    styleUrls: ['../app/pages/password-reset/password-reset.style.css']
    })
export class PasswordReset implements OnInit {

    @ViewChild('formChangePassword') formChangePassword: NgForm;

    private performanceContext: PerformanceContext | null = null;
    // the reset link is <host>/#/password-reset?passwordResetKey=<key>, so the key is in the query part of the fragment
    private passwordResetKey: string = this.getPasswordResetKeyFromUrl();

    submitting: boolean = false;
    attemptedSubmit: boolean = false;
    showPassword: boolean = false;
    newPassword: string = '';
    passwordFailedConstraints: boolean = false;
    loading: boolean = true;

    constructor(@Inject('MySynchFactory') private MSF:any,
                @Inject('ApiFactory') private api:any,
                @Inject(ActivatedRoute) private route: ActivatedRoute,
                @Inject(PerformanceMetricsService) private perfMetricSvc:PerformanceMetricsService,
                @Inject(PerformanceContextService) private perfContextSvc:PerformanceContextService,
                @Inject(ClientLoggerService) private log:ClientLoggerService){ }

    ngOnInit(): void {
        this.MSF.ready(() => {
            this.performanceContext = this.perfContextSvc.createPerformanceContext();
            this.perfMetricSvc.startTiming('Page:PasswordReset:Render');
            this.perfMetricSvc.startTiming('Page:PasswordResetPageData:Request');
            this.api.checkPasswordResetKey(this.passwordResetKey, this.performanceContext, (err:any, data:any) => {
                this.perfMetricSvc.endTiming("page", 'Page:PasswordResetPageData:Request', this.performanceContext);
                this.perfMetricSvc.startTiming('Page:PasswordReset:Build');
                if (err) {
                    this.log.warn('Invalid or expired password reset request');
                }

                if (!_.get(data, 'passwordResetOk', false)) {
                    this.perfMetricSvc.endTiming("page", 'Page:PasswordReset:Build', this.performanceContext);
                    this.MSF.loadPage('ForgotPassword', {expired: true});
                }

                this.loading = false;
                this.perfMetricSvc.endTiming("page", 'Page:PasswordReset:Build', this.performanceContext);
                this.perfMetricSvc.markPageReady('Page:PasswordReset:Render', this.performanceContext);
            });
        });
    }

    private getPasswordResetKeyFromUrl(): string {
        const fragment = this.route.snapshot.fragment || '';
        const queryString = fragment.split('?')[1] || '';
        return new URLSearchParams(queryString).get('passwordResetKey') || '';
    }

    // restores the initial state of the page
    resetDefaults(): void {
        this.submitting = false;
        this.attemptedSubmit = false;
        this.showPassword = false;
        this.newPassword = '';
        this.passwordFailedConstraints = false;
    }

    submit(): void {
        this.attemptedSubmit = true;
        this.passwordFailedConstraints = false;

        if (!this.formChangePassword.valid) {
            return;
        }

        if (this.newPassword.length < 6) {
            this.passwordFailedConstraints = true;
            return;
        }

        this.submitting = true;

        this.api.updatePasswordByPasswordResetKey(this.passwordResetKey, {
            passwordResetKey: this.passwordResetKey,
            password: this.newPassword
        }, (err:any, result:any) => {
            this.submitting = false;

            if (err) {
                this.log.error(err);

                if (err === 'invalid password') {
                    this.passwordFailedConstraints = true;
                } else {
                    return this.MSF.loadPage('ForgotPassword', {expired: true});
                }
            } else {
                this.log.info('Password updated.');

                this.MSF.notify.success('Your new password has been saved. Please sign in to continue.');
                this.MSF.loadPage('Login');
            }
        });
    }

    restartProcess(): void {
        this.MSF.loadPage('ForgotPassword');
    }
}
